import React from 'react'
import BusinessCategories from './BusinessCategories/BusinessCategories'
import FranchiseLocations from './FranchiseLocations/FranchiseLocations'
import GenericCasesBusiness from './BusinessSpecifics/BusinessSpecifics'

function ExampleBoxes () {
  return (
    <section>
      <BusinessCategories />
      <FranchiseLocations />
      <GenericCasesBusiness />
    </section>
  )
}

export default ExampleBoxes
